/* eslint-disable */
// /src/pages/SupportPage.jsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import BrandHeader from "../components/BrandHeader";
import { model } from "../services/firebase"; // Vertex AI Gemini 모델 import
import { useAppConfig } from "../context/AppConfigContext";

// ===== Layout =====
const Wrap = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, #D7E8FF 0%, #EAF3FF 100%);
  display: flex;
  flex-direction: column;
`;
const Sheet = styled.div`
  background: #F7FAFF;
  box-shadow: 0 -4px 20px rgba(0,0,0,.05);
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
`;
const Body = styled.div`
  flex: 1;
  padding: 16px;
  display: grid;
  grid-template-rows: auto auto 1fr auto; /* BrandHeader + headerImg + chat + bottompad */
  row-gap: 14px;
`;

/* 고객지원 헤더 이미지 */
const HeaderSection = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 4px;
  margin-bottom: 4px;
`;
const HeaderImg = styled.img`
  display: block;
  height: auto;
`;

const Section = styled.section`
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 1px 10px rgba(0,0,0,.06);
  padding: 0;
  display: grid;
  grid-template-rows: auto 1fr auto;
  overflow: hidden;
  min-height: 60vh;
`;
const BottomPad = styled.div`
  height: max(24px, env(safe-area-inset-bottom));
`;

// ===== Chat UI =====
const ChatHeader = styled.div`
  padding: 14px 16px;
  border-bottom: 1px solid rgba(0,0,0,.06);
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #224;
  background: #fff;
`;
const Dot = styled.span`
  width: 8px; height: 8px; border-radius: 50%;
  background: #7FB3FF;
  display: inline-block;
`;
const ChatScroll = styled.div`
  position: relative;
  overflow: auto;
  padding: 16px 12px 16px 12px;
  background: linear-gradient(180deg, #F9FCFF 0%, #FFFFFF 60%);
`;
const MsgWrap = styled.div`
  display: flex;
  margin: 6px 0;
  ${p => p.me ? "justify-content: flex-end;" : "justify-content: flex-start;"}
`;
const Bubble = styled.div`
  max-width: 78%;
  padding: 10px 12px;
  border-radius: 14px;
  font-size: 14px;
  line-height: 1.4;
  ${p => p.me
        ? "background: #D7E8FF; color:#133; border-top-right-radius:6px;"
        : "background: #F1F5F9; color:#233; border-top-left-radius:6px;"}
  box-shadow: 0 1px 3px rgba(0,0,0,.05);
  white-space: pre-wrap;
  word-break: break-word;
`;
const Time = styled.div`
  font-size: 11px; color: #99A; margin-top: 4px;
  ${p => p.me ? "text-align:right;" : "text-align:left;"}
`;
const Chips = styled.div`
  position: sticky; bottom: 0; left: 0; right: 0;
  display: flex; gap: 8px; flex-wrap: wrap;
  padding: 8px 12px 12px; background: linear-gradient(180deg, rgba(255,255,255,0) 0%, #fff 40%);
`;
const Chip = styled.button`
  border: 1px solid #D7E8FF;
  background: #fff;
  color: #246;
  padding: 8px 10px;
  border-radius: 999px;
  font-size: 13px;
  cursor: pointer;
  transition: .15s;
  &:hover { background: #F3F9FF; }
`;
const ChatInputBar = styled.form`
  display: grid; grid-template-columns: 1fr auto;
  gap: 8px; padding: 10px; border-top: 1px solid rgba(0,0,0,.06);
  background: #fff;
`;
const Input = styled.input`
  border: 1px solid #E3EAF3;
  border-radius: 12px;
  padding: 12px;
  font-size: 14px;
  outline: none;
  &:focus { border-color: #B6D6FF; box-shadow: 0 0 0 3px rgba(183,213,255,.35); }
`;
const SendBtn = styled.button`
  padding: 0 16px; border-radius: 12px; border: none;
  background: #7FB3FF; color: #fff; font-weight: 600; cursor: pointer;
  transition: .15s; min-width: 84px;
  &:disabled { background: #C9DFFF; cursor: not-allowed; }
  &:hover:not(:disabled){ filter: brightness(0.96); }
`;

// ===== Handoff / Queue / Rating =====
const HandoffCard = styled.div`
  border-top: 1px dashed #dbe7ff;
  background: #FAFCFF;
  padding: 12px;
`;
const H2 = styled.div` font-weight: 700; color:#244; margin-bottom: 6px; `;
const Small = styled.div` font-size: 12px; color:#789; `;
const Form = styled.form`
  display: grid; gap: 8px; margin-top: 10px;
  grid-template-columns: 1fr 1fr;
  @media (max-width: 480px) { grid-template-columns: 1fr; }
`;
const Select = styled.select`
  border: 1px solid #E3EAF3; border-radius: 10px; padding: 10px; font-size: 14px;
`;
const Field = styled.input`
  border: 1px solid #E3EAF3; border-radius: 10px; padding: 10px; font-size: 14px;
`;
const Row = styled.div` grid-column: 1 / -1; display: flex; align-items: center; gap: 8px; `;
const Primary = styled.button`
  border: none; padding: 10px 14px; border-radius: 12px; color:#fff; background:#4F93FF; font-weight: 700; cursor: pointer;
  &:disabled{ background:#bcd3ff; cursor:not-allowed; }
`;
const Ghost = styled.button`
  border: 1px solid #E3EAF3; padding: 10px 14px; border-radius: 12px; color:#345; background:#fff; font-weight: 600; cursor: pointer;
`;
const QueueBanner = styled.div`
  position: sticky; top: 0; margin: -16px -12px 8px; padding: 10px 12px;
  background: #FFF6D9; color:#5A4510; font-size: 13px; border-bottom: 1px solid #F0E2B0;
`;
const RatingWrap = styled.div`
  border-top: 1px dashed #e9edf5; padding: 12px; background:#FDFEFF;
`;
const Stars = styled.div` display: flex; gap: 6px; margin: 8px 0; `;
const StarBtn = styled.button`
  width: 34px; height: 34px; border-radius: 50%;
  border: 1px solid #E3EAF3; background:#fff; cursor: pointer; font-size: 16px;
  &.on { background:#FFE699; border-color:#E3C766; }
`;

// ===== Utilities =====
const nowHHMM = () => new Date().toTimeString().slice(0, 5);

// ===== Main Page =====
export default function SupportPage() {
    // "bot" | "handoff_form" | "queuing" | "live" | "ended"
    const [chatState, setChatState] = useState("bot");
    const [input, setInput] = useState("");
    const [typing, setTyping] = useState(false);
    const [rating, setRating] = useState(0);
    const [form, setForm] = useState({
        name: "",
        phone: "",
        category: "결제",
        agree: false,
    });
    const listRef = useRef(null);

    const [messages, setMessages] = useState(() => [
        { id: "m1", role: "bot", text: "안녕하세요! 무엇을 도와드릴까요?", time: nowHHMM() },
    ]);

    // AppConfig: 고객지원 헤더 이미지
    const { config, loading: configLoading } = useAppConfig();
    const detail = config.detailScreens || {};
    const csCfg = detail.customerSupport || {};
    const headerImg = csCfg.headerImg || "";

    // ===== AI 호출 헬퍼 =====
    const askAi = async (userText, replyRole = "bot") => {
        // replyRole: "bot" (초기 봇), "agent" (핸드오프 후 AI 상담사)
        setTyping(true);
        try {
            // 기본 시스템 컨텍스트
            const basePrompt =
                "너는 DH 모빌리티(택시/가맹/정산/앱 사용)를 도와주는 한국어 고객지원 AI 상담사야. " +
                "짧고 친절하게, 점심시간 카톡하듯 말해줘. 어려운 용어는 쉽게 풀어서 설명해 줘.";

            const fullPrompt = `${basePrompt}\n\n사용자 질문:\n"""${userText}"""`;

            const result = await model.generateContent({
                contents: [
                    {
                        role: "user",
                        parts: [{ text: fullPrompt }],
                    },
                ],
            });

            const text =
                result?.response?.text?.() ||
                result?.response?.candidates?.[0]?.content?.parts?.[0]?.text ||
                "죄송해요, 지금은 답변을 잘 못 만들었어요. 다시 한번만 질문해 주실 수 있을까요?";

            setMessages((prev) => [
                ...prev,
                {
                    id: `ai_${Date.now()}`,
                    role: replyRole,
                    text,
                    time: nowHHMM(),
                },
            ]);
        } catch (err) {
            console.error("AI error:", err);
            setMessages((prev) => [
                ...prev,
                {
                    id: `err_${Date.now()}`,
                    role: "bot",
                    text: "잠시 오류가 발생했어요. 네트워크 상태를 확인하시고 다시 시도해 주세요.",
                    time: nowHHMM(),
                },
            ]);
        } finally {
            setTyping(false);
        }
    };

    // 자동 스크롤
    useEffect(() => {
        const el = listRef.current;
        if (el) el.scrollTop = el.scrollHeight;
    }, [messages, typing]);

    const sendUser = (text) => {
        if (!text.trim()) return;
        const trimmed = text.trim();
        setMessages((prev) => [
            ...prev,
            { id: `u_${Date.now()}`, role: "user", text: trimmed, time: nowHHMM() },
        ]);
        setInput("");

        // 특정 키워드에선 핸드오프 유도 메시지
        if (/상담|사람|해결 안됨|환불|결제 오류/i.test(trimmed)) {
            setTimeout(() => {
                setMessages((prev) => [
                    ...prev,
                    {
                        id: `sys_${Date.now()}`,
                        role: "bot",
                        text: "필요하시면 상담사에게 연결해드릴게요. '상담사 연결' 버튼을 이용해 주세요.",
                        time: nowHHMM(),
                    },
                ]);
            }, 300);
        }

        const replyRole = chatState === "live" ? "agent" : "bot";
        askAi(trimmed, replyRole);
    };

    const onChip = (t) => sendUser(t);

    const submitHandoffForm = (e) => {
        e.preventDefault();
        if (!form.name || !form.phone || !form.agree) return;
        setChatState("queuing");
        setMessages((prev) => [
            ...prev,
            {
                id: `sys_${Date.now()}`,
                role: "bot",
                text: "AI 상담사 연결을 요청했어요. 잠시만 기다려주세요.",
                time: nowHHMM(),
            },
        ]);

        // 더미 큐: 1.5초 후 AI 상담사 입장
        setTimeout(() => {
            setChatState("live");
            setMessages((prev) => [
                ...prev,
                {
                    id: `ag_${Date.now()}`,
                    role: "agent",
                    text: `안녕하세요, ${form.name}님. AI 상담사입니다. 어떤 부분이 가장 궁금하신가요?`,
                    time: nowHHMM(),
                },
            ]);
        }, 1500);
    };

    const endChat = () => {
        setChatState("ended");
        setMessages((prev) => [
            ...prev,
            {
                id: `sys_${Date.now()}`,
                role: "bot",
                text: "대화를 종료했어요. 이용해 주셔서 감사합니다.",
                time: nowHHMM(),
            },
        ]);
    };

    const sendInLive = (text) => {
        if (!text.trim()) return;
        const trimmed = text.trim();
        setMessages((prev) => [
            ...prev,
            { id: `u_${Date.now()}`, role: "user", text: trimmed, time: nowHHMM() },
        ]);
        setInput("");
        askAi(trimmed, "agent");
    };

    const chips = useMemo(
        () => [
            "DH 모빌리티에 대해 알고싶어요",
            "가맹가입",
            "콜/운행",
            "앱/기기 사용",
            "매출순위",
            "미터점이용법",
            "정산절차",
            "AI 상담사 연결 원해요",
        ],
        []
    );

    const onSubmitInput = (e) => {
        e.preventDefault();
        if (!input.trim()) return;
        if (chatState === "live") sendInLive(input);
        else sendUser(input);
    };

    return (
        <Wrap>
            <Sheet>
                <Body>
      

                    {/* 고객지원 헤더 이미지 (설정값) */}
                    {!configLoading && headerImg && (
                        <HeaderSection>
                            <HeaderImg src={headerImg} alt="고객지원 헤더" />
                        </HeaderSection>
                    )}

                    <Section>
                        <ChatHeader>
                            <Dot /> <span>도움말 상담</span>
                        </ChatHeader>

                        <ChatScroll ref={listRef}>
                            {chatState === "queuing" && (
                                <QueueBanner>
                                    상담사 연결까지 잠시만 기다려주세요… (예상 1~2분)
                                </QueueBanner>
                            )}

                            {messages.map((m) => (
                                <MsgWrap key={m.id} me={m.role === "user"}>
                                    <div>
                                        <Bubble me={m.role === "user"}>{m.text}</Bubble>
                                        <Time me={m.role === "user"}>{m.time}</Time>
                                    </div>
                                </MsgWrap>
                            ))}

                            {typing && (
                                <MsgWrap>
                                    <Bubble>입력 중…</Bubble>
                                </MsgWrap>
                            )}

                            {/* 상담사 연결 폼 (핸드오프) */}
                            {chatState === "handoff_form" && (
                                <HandoffCard>
                                    <H2>상담사 연결을 위해 정보를 입력해 주세요</H2>
                                    <Small>
                                        빠른 도움을 드리기 위해 최소한의 정보만 요청드려요.
                                    </Small>
                                    <Form onSubmit={submitHandoffForm}>
                                        <Field
                                            placeholder="이름"
                                            value={form.name}
                                            onChange={(e) =>
                                                setForm((v) => ({ ...v, name: e.target.value }))
                                            }
                                        />
                                        <Field
                                            placeholder="연락처 (숫자만)"
                                            value={form.phone}
                                            onChange={(e) =>
                                                setForm((v) => ({ ...v, phone: e.target.value }))
                                            }
                                        />
                                        <Select
                                            value={form.category}
                                            onChange={(e) =>
                                                setForm((v) => ({ ...v, category: e.target.value }))
                                            }
                                        >
                                            <option value="결제">결제</option>
                                            <option value="계정">계정</option>
                                            <option value="이용문의">이용문의</option>
                                            <option value="기타">기타</option>
                                        </Select>
                                        <Row>
                                            <label style={{ fontSize: 13, color: "#456" }}>
                                                <input
                                                    type="checkbox"
                                                    checked={form.agree}
                                                    onChange={(e) =>
                                                        setForm((v) => ({ ...v, agree: e.target.checked }))
                                                    }
                                                />{" "}
                                                개인정보 제공에 동의합니다.
                                            </label>
                                        </Row>
                                        <Row style={{ gap: 8 }}>
                                            <Primary
                                                type="submit"
                                                disabled={!form.name || !form.phone || !form.agree}
                                            >
                                                상담사 연결 요청
                                            </Primary>
                                            <Ghost
                                                type="button"
                                                onClick={() => setChatState("bot")}
                                            >
                                                취소
                                            </Ghost>
                                        </Row>
                                    </Form>
                                </HandoffCard>
                            )}

                            {/* 종료 후 평가 */}
                            {chatState === "ended" && (
                                <RatingWrap>
                                    <H2>만족도 평가</H2>
                                    <Small>
                                        서비스 품질 향상을 위해 별점을 남겨주세요.
                                    </Small>
                                    <Stars>
                                        {[1, 2, 3, 4, 5].map((n) => (
                                            <StarBtn
                                                key={n}
                                                className={rating >= n ? "on" : ""}
                                                onClick={() => setRating(n)}
                                                type="button"
                                                aria-label={`${n}점`}
                                            >
                                                ★
                                            </StarBtn>
                                        ))}
                                    </Stars>
                                    <Small>감사합니다!</Small>
                                </RatingWrap>
                            )}

                            {/* 봇 단계에서 추천 칩 */}
                            {chatState === "bot" && (
                                <Chips>
                                    {chips.map((c, i) => (
                                        <Chip key={i} onClick={() => onChip(c)}>
                                            {c}
                                        </Chip>
                                    ))}
                                </Chips>
                            )}

                            {/* 라이브 단계에서 종료 버튼 */}
                            {chatState === "live" && (
                                <Chips>
                                    <Ghost type="button" onClick={endChat}>
                                        대화 종료
                                    </Ghost>
                                </Chips>
                            )}
                        </ChatScroll>

                        <ChatInputBar onSubmit={onSubmitInput}>
                            <Input
                                value={input}
                                onChange={(e) => setInput(e.target.value)}
                                placeholder={
                                    chatState === "live"
                                        ? "상담사에게 메시지 보내기"
                                        : "무엇을 도와드릴까요?"
                                }
                            />
                            <SendBtn type="submit" disabled={!input.trim() || typing}>
                                {typing ? "응답 중…" : "보내기"}
                            </SendBtn>
                        </ChatInputBar>
                    </Section>

                    <BottomPad />
                </Body>
            </Sheet>
        </Wrap>
    );
}
